import { createFileRoute } from '@tanstack/react-router';
import { MyLeavePage } from '@/features/shifts/pages/my-leave-page';

export const Route = createFileRoute('/_app/me/leave')({ component: MyLeavePage });
